module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['markdown-editor', _vm.classes]
  }, [_c('div', {
    staticClass: "options"
  }, [_c('i', {
    class: ['fa fa-eye', {
      selected: _vm.previewVisible
    }],
    on: {
      "click": function($event) {
        _vm.togglePreview()
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa fa-question-circle', {
      selected: _vm.formattingHelpVisible
    }],
    on: {
      "click": function($event) {
        _vm.toggleHelp()
      }
    }
  })]), _vm._v(" "), _c('textarea', {
    attrs: {
      "title": "content",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateContent
    }
  }), _vm._v(" "), (_vm.formattingHelpVisible) ? _c('div', {
    staticClass: "formatting-help"
  }, [_c('h1', [_vm._v("Formatting Help")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.previewVisible) ? _c('div', {
    staticClass: "preview"
  }, [_c('h1', [_vm._v("Preview")]), _vm._v(" "), _c('markdown-content', {
    attrs: {
      "classes": "preview-content",
      "content": _vm.value
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Description")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("Syntax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Headlines")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("# Largest Headline"), _c('br'), _vm._v("## Next Largest Headline"), _c('br'), _vm._v("###### Smallest Headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Italics")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("*text*, _text_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Bold")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("**text**, __text__")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Link")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("[Link Text](http://google.com)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Image")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("![Alt Text](http://image.jpg)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Linked Image")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("[Above Syntax for Image](http://google.com)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Youtube Clip")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("[youtube:VIDEO_ID]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Font Awesome Icon")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("[icon:icon-name]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Bullet List")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("* Item 1"), _c('br'), _vm._v("* Item 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Numbered List")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("1. Item 1"), _c('br'), _vm._v("2. Item 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Quote")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("> Some text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Code Line")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("`let x = 7;`")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Code Block")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("``` js|csharp|html"), _c('br'), _vm._v("let x = function({"), _c('br'), _vm._v("     return 10;"), _c('br'), _vm._v("});"), _c('br'), _vm._v("```")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("Horizontal Line")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_vm._v("---, ___, or *** on its own line")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rule"
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v("View more at: ")]), _vm._v(" "), _c('span', {
    staticClass: "syntax"
  }, [_c('a', {
    attrs: {
      "href": "http://assemble.io/docs/Cheatsheet-Markdown.html",
      "target": "_blank"
    }
  }, [_vm._v("http://assemble.io/docs/Cheatsheet-Markdown.html")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2a872da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/MarkdownEditor/MarkdownEditor.vue
// module id = 906
// module chunks = 2